import { Button } from "@/components/ui/UIElements/Button";
import React, { useEffect, useMemo, useState } from "react";
import { clamp, numOnly, parseTime } from "./BusinessZones.utils";
import { NativeSelect } from "../../UIElements/Select";

const TimeEditor = ({ label, value, onSave, isSaving }) => {
  const initial = useMemo(() => parseTime(value), [value]);
  const [hour, setHour] = useState(initial.h);
  const [minute, setMinute] = useState(initial.m);

  useEffect(() => {
    const { h, m } = parseTime(value);
    setHour(h);
    setMinute(m);
  }, [value]);

  const handleSave = () => {
    const h = clamp(hour, 0, 23);
    const m = clamp(minute, 0, 59);
    if (h === "" || m === "") return;
    onSave(`${h}:${m}`);
  };

  const invalid =
    hour === "" ||
    minute === "" ||
    Number(hour) < 0 ||
    Number(hour) > 23 ||
    Number(minute) < 0 ||
    Number(minute) > 59;
  const changed = hour !== initial.h || minute !== initial.m;

  return (
    <div className="space-y-2">
      <label className="text-foreground block text-sm font-medium">
        {label}
      </label>
      <div className="flex items-center gap-2">
        <NativeSelect
          value={hour}
          onChange={(e) => setHour(numOnly(e.target.value))}
          className="custom-select border-border bg-card focus:ring-ring h-10 rounded-md border px-3 py-2 text-sm text-white focus:border-transparent focus:ring-2 focus:outline-none"
        >
          <option value="" disabled>
            HH
          </option>
          {Array.from({ length: 24 }).map((_, i) => (
            <option key={i} value={String(i)}>
              {i}
            </option>
          ))}
        </NativeSelect>
        <span className="text-muted-foreground">:</span>
        <NativeSelect
          value={minute}
          onChange={(e) => setMinute(numOnly(e.target.value))}
          className="custom-select border-border bg-card focus:ring-ring h-10 rounded-md border px-3 py-2 text-sm text-white focus:border-transparent focus:ring-2 focus:outline-none"
        >
          <option value="" disabled>
            MM
          </option>
          {Array.from({ length: 60 }).map((_, i) => (
            <option key={i} value={String(i)}>
              {i}
            </option>
          ))}
        </NativeSelect>
        <Button
          variant="default"
          onClick={handleSave}
          disabled={invalid || !changed || isSaving}
          className="flex items-center justify-center px-3 py-2 disabled:cursor-not-allowed disabled:opacity-50"
        >
          {isSaving ? (
            <div className="h-4 w-4 animate-spin rounded-full border-b-2 border-white"></div>
          ) : (
            "Save"
          )}
        </Button>
      </div>
      {invalid && (
        <p className="text-destructive text-xs">
          Enter a valid time (0-23 : 0-59)
        </p>
      )}
    </div>
  );
};

export default TimeEditor;
